import Vue from 'vue'
import VueGtm from 'vue-gtm'
import App from './components/App'
import ServiceInformation from './mixin/service_information'

Vue.mixin(ServiceInformation)

function gtmId () {
  if (location.host.includes('kobot')) {
    // kobotドメインの場合、dip側のGTMを利用
    return 'GTM-K8WPG2FG'
  }
  // Leadle側のGTMを利用する
  return 'GTM-NN6XLPWJ'
}

Vue.use(VueGtm, {
  id: gtmId(),
})

export default function createApp ({ router, store }) {
  return new Vue({
    router,
    store,
    components: { App },
    template: '<App/>',
  })
}



// WEBPACK FOOTER //
// ./src/app.js